var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loggedIn
    ? _c("div", { staticClass: "goc-activity-container" }, [
        _c("p", { staticClass: "main-title" }, [
          _vm._v(
            "\n    Please select the gift collection you purchased. Your activity will populate below! You'll also be able to manage your entire campaign, search users,  resend notification emails, and have access to redemption links.\n  "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "collection-selection-container" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v("Please select a collection:")
          ]),
          _vm._v(" "),
          _vm.collections.length > 0 || _vm.emails.length > 0
            ? _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedGOC,
                      expression: "selectedGOC"
                    }
                  ],
                  staticClass: "variant-selector",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedGOC = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _vm._l(_vm.collections, function(collection) {
                    return _c(
                      "option",
                      {
                        key: collection.handle,
                        domProps: { value: collection.handle }
                      },
                      [_vm._v(_vm._s(collection.name))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.emails.length > 0
                    ? _c("option", { attrs: { value: "emailSends" } }, [
                        _vm._v("Gift Boxes Sent with an Email")
                      ])
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.selectedGOC
          ? _c("div", { staticClass: "collection-report-container" }, [
              _c("div", { staticClass: "charts-container" }, [
                _c(
                  "div",
                  { staticClass: "claimed-chart" },
                  [
                    _c("apexchart", {
                      attrs: {
                        type: "donut",
                        options: _vm.reclaimedChartOptions,
                        series: _vm.reclaimedChartData
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "unclaimed-chart" },
                  [
                    _c("apexchart", {
                      attrs: {
                        type: "donut",
                        options: _vm.unclaimedChartOptions,
                        series: _vm.unclaimedChartData
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "email-container" },
                [
                  _c("div", { staticClass: "email-actions-container" }, [
                    _c("div", { staticClass: "actions-container" }, [
                      _c(
                        "button",
                        {
                          staticClass: "happybox-button yellow",
                          attrs: { disabled: _vm.canBulkResend == false },
                          on: {
                            click: function($event) {
                              return _vm.openResendAlert(_vm.itemsSelected)
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src:
                                "https://cdn.shopify.com/s/files/1/0600/4401/7839/files/email.svg?v=1698159625"
                            }
                          }),
                          _vm._v(" Resend reminder series")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "happybox-button purple",
                          attrs: { disabled: _vm.canBulkCancel == false },
                          on: {
                            click: function($event) {
                              return _vm.openCancelAlert(_vm.itemsSelected)
                            }
                          }
                        },
                        [_c("span", [_vm._v("X")]), _vm._v(" Cancel selected")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "vue-good-table",
                    {
                      attrs: {
                        columns: _vm.tableHeaders,
                        rows: _vm.tableData,
                        styleClass: "vgt-table striped bordered condensed",
                        "search-options": {
                          enabled: true
                        },
                        "sort-options": {
                          enabled: true
                        },
                        "pagination-options": {
                          enabled: true,
                          mode: "pages",
                          perPage: 50,
                          dropdownAllowAll: false
                        },
                        "select-options": {
                          enabled: true,
                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                          selectionInfoClass: "custom-class",
                          selectionText: "rows selected",
                          clearSelectionText: "clear"
                        }
                      },
                      on: { "on-selected-rows-change": _vm.tbSelectionChanged },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "table-row",
                            fn: function(props) {
                              return [
                                props.column.field == "actions"
                                  ? _c("span", [
                                      _c(
                                        "div",
                                        { staticClass: "actions-icons" },
                                        [
                                          props.row.status != "Claimed" &&
                                          props.row.status != "Cancelled"
                                            ? _c(
                                                "p",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: {
                                                        content: "Cancel Order",
                                                        container: false
                                                      },
                                                      expression:
                                                        "{content: 'Cancel Order',container: false }"
                                                    }
                                                  ],
                                                  attrs: {
                                                    src:
                                                      "https://cdn.shopify.com/s/files/1/0600/4401/7839/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1698249866"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openCancelAlert(
                                                        [props.row]
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("X")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          props.row.status != "Claimed" &&
                                          props.row.status != "Scheduled" &&
                                          props.row.status != "Cancelled"
                                            ? _c("img", {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value: {
                                                      content:
                                                        "Resend reminder",
                                                      container: false
                                                    },
                                                    expression:
                                                      "{content: 'Resend reminder',container: false }"
                                                  }
                                                ],
                                                attrs: {
                                                  src:
                                                    "https://cdn.shopify.com/s/files/1/0600/4401/7839/files/email.svg?v=1698159625"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openResendAlert([
                                                      props.row
                                                    ])
                                                  }
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ])
                                  : props.column.field == "link"
                                  ? _c("span", [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "clickable",
                                          on: {
                                            click: function($event) {
                                              return _vm.copyLink(
                                                props.row.href
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(props.row.link))]
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            props.formattedRow[
                                              props.column.field
                                            ]
                                          ) +
                                          "\n          "
                                      )
                                    ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3561618668
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "table-footer",
                          attrs: { slot: "table-actions-bottom" },
                          slot: "table-actions-bottom"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "hb-btn primary",
                              attrs: {
                                disabled: _vm.itemsSelected.length == 0
                              },
                              on: {
                                click: function($event) {
                                  return _vm.downloadXlsx(_vm.itemsSelected)
                                }
                              }
                            },
                            [_vm._v("Export Selected")]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isLoading
          ? _c("div", { staticClass: "spinner-container" }, [
              _c("div", { staticClass: "spinner" })
            ])
          : _vm._e()
      ])
    : _c("div", { staticClass: "loading-container" }, [
        _c("div", { staticClass: "spinner" })
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }